<template>
  <a v-if="previewMode" :href="externalUrl" :alt="title" target="_blank">
    <img src="@/assets/edit.svg" alt=""/>
    <span v-if="title">{{ title }}</span>
  </a>
</template>

<script>

import {MoqoApi} from '@/lib/MoqoApi.js'

export default {
  name: 'AdminEdit',
  props: {
    url: {
      type: String,
      required: true
    },

    title: {
      type: String
    }
  },

  computed: {
    externalUrl () {
      return `${this.backendHost}${this.url}`
    }
  }
}
</script>

<style lang="scss" scoped>

a {
  display: block;
  position: absolute;
  z-index: 99999;
  padding: 5px 5px;
  background-color: #cdcdcd;
  border-radius: 4px;
  opacity: 0.5;
  margin: 2px;
  text-decoration: none;
  line-height: rem-calc(15);
  font-size: rem-calc(15);
  span {
    display: none;
    opacity: 0;
    color: #666;
  }
  &:hover {
    opacity: 0.8;
    span {
      padding-left: 5px;
      display: inline-block;
      opacity: 1;
    }
  }
  img {
    width: 15px;
    float: left;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AdminEdit.vue